// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProgressBar test Match con el snapshot 1`] = `""`;
